import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import * as React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

import { IconContainer } from '@/atoms/IconContainer/IconContainer';
import { CommonStyles } from '@/atoms/Menu/RadixMenu/common';
import CheckIcon from '@/icons/check.svg?react';

export const CheckboxItem = React.forwardRef<
  HTMLDivElement,
  DropdownMenuPrimitive.DropdownMenuCheckboxItemProps
>(({ children, checked, onCheckedChange, ...props }, forwardedRef) => {
  return (
    <StyledCheckboxItem
      checked={checked}
      onCheckedChange={onCheckedChange}
      ref={forwardedRef}
      {...props}
    >
      <DropdownMenuPrimitive.ItemIndicator className='absolute left-1 top-1/2 -translate-y-1/2'>
        {checked === true && (
          <IconContainer className='h-4 w-4 flex-shrink-0' color='gray'>
            <CheckIcon />
          </IconContainer>
        )}
      </DropdownMenuPrimitive.ItemIndicator>
      {children}
    </StyledCheckboxItem>
  );
});

const StyledCheckboxItem = styled(DropdownMenuPrimitive.CheckboxItem)`
  ${CommonStyles}

  ${tw`flex flex-row items-center`}

  &[data-state='checked'] {
    ${tw`font-semibold`}
  }
`;
